module.exports = __webpack_public_path__ + "media/images/flags/32/Myanmar-bbe7ca3e361ea76c112446302d4c14d1.png";